module.exports = __webpack_public_path__ + "e410e0dbaf9f7229db148e4b6306d6b6.svg";